import GiftCardExpandButton from 'components/Checkout/Sections/Payment/GiftCardSection/GiftCardExpandButton/GiftCardExpandButton';

export default GiftCardExpandButton;
